import QRCode from 'qrcode'

/**
 * A QR code as an SVG path, made in the browser. A ticket's QR payload is its code
 * (`qrPayloadFor` in the API), so the console draws the same QR the ticket email carries.
 *
 * `size` counts the modules with the quiet zone: four light modules on each side, which a
 * scanner needs to find the code.
 */
export type QrShape = { size: number; path: string }

const QUIET = 4

export function qrShape(text: string): QrShape {
  const { modules } = QRCode.create(text, { errorCorrectionLevel: 'M' })
  const parts: string[] = []
  for (let row = 0; row < modules.size; row += 1) {
    for (let col = 0; col < modules.size; col += 1) {
      if (modules.get(row, col) === 1) parts.push(`M${col + QUIET} ${row + QUIET}h1v1h-1z`)
    }
  }
  return { size: modules.size + QUIET * 2, path: parts.join('') }
}

/** The QR as an SVG document, for a page made to print. It holds numbers only, so it is safe. */
export function qrSvg(text: string, sizeMm: number): string {
  const { size, path } = qrShape(text)
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" width="${sizeMm}mm" height="${sizeMm}mm" shape-rendering="crispEdges"><rect width="${size}" height="${size}" fill="#fff"/><path d="${path}" fill="#000"/></svg>`
}
